import React, { useState, useEffect } from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { faPlus, faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// INTERFACES
import { FormularyRowSelectCountryInterface } from "../../../interfaces/FormularyRow";

export default function FormularyRowSelectCountry({
	record,
	text,
	value,
	inputIcon,
	formAction,
	itemId,
	textLink,
	onChangeFormValue,
	countries,
}: FormularyRowSelectCountryInterface) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const { Option } = Select;

	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [listCountries, setListCountries] = useState<any[]>([]);

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// USE EFFECT ************************************* */
	useEffect(() => {
		if (countries && countries.data && countries.data.length > 0) {
			setListCountries(countries.data);
		}
	}, [countries]);

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<>
			{record.id === "" ? (
				<Select
					className='generalStyles__width100'
					showSearch
					optionFilterProp='children'
					onChange={(e: any) => {
						onChangeFormValue(e, "country");
					}}
					filterOption={(input: any, option: any) => option.children.toLowerCase().includes(input.toLowerCase())}
					size='small'
					value={formAction === "create" ? value : null}
					disabled={formAction === "edit"}
					suffixIcon={inputIcon ? <FontAwesomeIcon icon={faPlus} className='generalStyles__info' /> : null}
				>
					{listCountries.map((c: any) => (
						<Option key={c.name} value={c.name}>
							{c.name}
						</Option>
					))}
				</Select>
			) : (
				<>
					{formAction === "edit" && record.id === itemId ? (
						<Select
							className='generalStyles__width100'
							showSearch
							optionFilterProp='children'
							onChange={(e: any) => {
								onChangeFormValue(e, "country");
							}}
							filterOption={(input: any, option: any) => option.children.toLowerCase().includes(input.toLowerCase())}
							size='small'
							value={value}
							suffixIcon={inputIcon ? <FontAwesomeIcon icon={faPen} className='generalStyles__info' /> : null}
						>
							{listCountries.map((c: any) => (
								<Option key={c.name} value={c.name}>
									{c.name}
								</Option>
							))}
						</Select>
					) : (
						<div className={textLink ? "generalStyles__info" : ""}>{text}</div>
					)}
				</>
			)}
		</>
	);
}
